import {createReducer} from "typesafe-actions";
import { SELECT_TIME_PERIOD } from "../actions";
import { TimePeriod } from "../types";

export const timePeriodReducer = createReducer<TimePeriod>(TimePeriod.ALL)
   .handleAction(SELECT_TIME_PERIOD, (state, action) => action.payload);